/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-03",
    versionChannel: "nightly",
    buildDate: "2025-04-03T00:06:38.534Z",
    commitHash: "7935821fc38cd16dfc9bb83a8e8311246377e607",
};
